<template>
  <v-container id="categorias" tag="section">
    <base-v-component heading="CARTA DIGIAL " />
    <base-material-card color="indigo" icon="mdi-newspaper" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" :loading="loadingForm" dark class="mb-2" @click.stop="save()">Guardar</v-btn>
        <v-spacer />
      </v-toolbar>
      <v-row v-if="negocioObj.id == 'padthaiwok'">
        <v-col cols="10">
          <v-card class="mx-auto">
            <v-card-title>
              <v-spacer />
              <h4 class="text-center">Compatibilidad Padthaiwok</h4>
              <v-spacer />
            </v-card-title>
            <v-card-text>
              <v-alert
                class="mt-2 info white--text"
              >Desde aquí se puede redirigir la solicitud a los antiguos enlaces /docs/carta_digital a la carta digital</v-alert>
              <v-textarea v-model="redirec" background-color="#efefef" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      redirec: "",
      loadingForm: false,
    };
  },
  computed: {
    ...mapGetters({
      negocioObj: ["app/negocioGestObj"],
    }),
    redirecComputado: {
      get() {
        return this.redirec.split("\n").map((linea) => {
          let a = linea.split(",");
          return {
            origen: a[0] ? a[0].trim() : "",
            destino: a[1] ? a[1].trim() : "",
          };
        });
      },
    },
  },
  methods: {
    save() {
      let _vm = this;
      _vm.loadingForm = true;
      console.log(this.redirecComputado);
      this.$store
        .dispatch("carta/saveCompatibilidadCarta", {
          compatibilidad: this.redirecComputado,
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Redirecciones guardadas",
          });
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido guardar la redirección: " + e,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
  },
  mounted() {
    if (
      this.negocioObj &&
      this.negocioObj.carta &&
      this.negocioObj.carta.compatibilidad &&
      Array.isArray(this.negocioObj.carta.compatibilidad)
    ) {
      this.redirec = this.negocioObj.carta.compatibilidad
        .filter((l) => l.origen.length > 0)
        .map((linea) => {
          console.log(linea);
          return linea.origen + "," + linea.destino;
        })
        .join("\n");
    }
  },
};
</script>

<style>
</style>